import { LoadingController, Loading, ToastController } from 'ionic-angular';

export class ConMensajes {

  constructor(
    public toastCtrl: ToastController
  ) {

  }

  // #region Métodos de la clase
  /**
   * Presenta un mensaje informando del error
   * @param texto Explicación del error
   * @param operacion Operación que se estaba realizando
   */
  public Error(texto: string | object, operacion: string): void {

    // Se comprueba si el texto es un objeto, para realizar un JSON.stringify
    if (typeof texto === 'object') {
      texto = JSON.stringify(texto);
    }

    let toast = this.toastCtrl.create({
      message: operacion + " :: " + texto,
      position: 'bottom',
      cssClass: 'rojo',
      showCloseButton: true,
      closeButtonText: 'OK'
    });
    toast.present();

  }

  /**
   * Muestra un mensaje en forma de 'toast'
   * @param texto   Texto a mostrar
   * @param duracion    Duración en milisegundos del mensaje. En el caso de que se especifique 0 o no se especifique, se mostrará el 'toast' con un botón de OK para cerrar el mensaje
   */
  public Mensaje(texto: string | any, duracion?: number): void {

    // Se comprueba si el texto es un objeto, para realizar un JSON.stringify
    if (typeof texto === 'object') {
      texto = JSON.stringify(texto);
    }

    if (duracion == undefined || duracion == 0) {
      let toast = this.toastCtrl.create({
        message: texto,
        position: 'bottom',
        showCloseButton: true,
        closeButtonText: 'OK'
      });
      toast.present();
    }
    else {
      let toast = this.toastCtrl.create({
        message: texto,
        position: 'bottom',
        duration: duracion
      });
      toast.present();
    }
  }
  // #endregion
}

export class PaginaBasica extends ConMensajes {

  // #region Propiedades de la clase
  public carga: Loading;
  public cargando: boolean;
  // #endregion

  constructor(
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController
  ) {
    super(toastCtrl);
  }

  // #region Métodos del controlador

  /**
   * Presenta un mensaje informando del error
   * @param texto Explicación del error
   * @param operacion Operación que se estaba realizando
   */
  public Error(texto: string | object, operacion: string): void {

    // Comprueba si se está cargando algo
    if (this.cargando) {
      try {
        this.carga.dismissAll();
      } catch (error) { }
    }

    // Se comprueba si el texto es un objeto, para realizar un JSON.stringify
    if (typeof texto === 'object') {
      texto = JSON.stringify(texto);
    }

    let toast = this.toastCtrl.create({
      message: operacion + " :: " + texto,
      position: 'bottom',
      cssClass: 'rojo',
      showCloseButton: true,
      closeButtonText: 'OK'
    });
    toast.present();

  }

  /**
   * Muestra un mensaje en forma de 'toast'
   * @param texto   Texto a mostrar
   * @param duracion    Duración en milisegundos del mensaje. En el caso de que se especifique 0 o no se especifique, se mostrará el 'toast' con un botón de OK para cerrar el mensaje
   */
  public Mensaje(texto: string | any, duracion?: number): void {

    // En el caso de que se esté cargando algo, se quita la carga
    if (this.cargando) {
      try {
        this.carga.dismissAll();
      }
      catch (e) { }
    }

    // Se comprueba si el texto es un objeto, para realizar un JSON.stringify
    if (typeof texto === 'object') {
      texto = JSON.stringify(texto);
    }

    if (duracion == undefined || duracion == 0) {
      let toast = this.toastCtrl.create({
        message: texto,
        position: 'bottom',
        showCloseButton: true,
        closeButtonText: 'OK'
      });
      toast.present();
    }
    else {
      let toast = this.toastCtrl.create({
        message: texto,
        position: 'bottom',
        duration: duracion
      });
      toast.present();
    }
  }

  /**
   * Muestra u ocula el componente "Loading" de IONIC
   * @param forzarOcultar Indica si se quiere forzar que se oculte la carga
   * @param texto   Texto que se quiere poner en la ventana de carga
   */
  public MostrarOcultarCarga(forzarOcultar: boolean = false, texto?: string): void {
    try {
      if (this.cargando || forzarOcultar) {
        this.cargando = false;
        this.carga.dismissAll();
      }
      else {
        this.carga = this.loadingCtrl.create({
          spinner: 'dots',
          content: texto != undefined ? texto : "cargando"
        });
        this.carga.present();
        this.cargando = true;
      }
    }
    catch (e) {
      console.error("Problema al usar el componente Loading de IONIC: " + JSON.stringify(e));
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/models/PaginaBase.ts